import React, { useEffect } from "react";
import { Button, Form, Input, Radio, Select, Alert } from "antd";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import { wait } from "@testing-library/user-event/dist/utils";

function FormSec() {
  const [form] = Form.useForm();
  const [formLayout, setFormLayout] = useState("vertical");
  const [isLoadingg, setIsLoadingg] = useState(false);
  const [error, setError] = useState(null);
  const [resError, setResError] = useState(null);
  const [post, setPost] = useState(null);

  // console.log(isLoadingg, "watch it bro!!");

  const onFormLayoutChange = ({ layout }) => {
    setFormLayout(layout);
  };

  const formItemLayout = formLayout === "vertical" ? {} : null;
  const buttonItemLayout = formLayout === "vertical" ? {} : null;
  const navigate = useNavigate();

  const onFinish = (values) => {
    // console.log("Success:", values);
    form.resetFields();

    const waitlistData = {
      email: values.emailaddress,
      phone: values.phonenumber,
      fullname: values.fullname,
      referral: values.referralemail,
    };

    sendPost(waitlistData);

    function sendPost(waitlistData) {
      setIsLoadingg(true);
      axios
        .post(
          "https://shopaz-waitinglist.herokuapp.com/v1/user/shoppers",
          waitlistData,
          {
            headers: {
              "x-api-key": "152e3cf2-15ad-11ec-82a8-0242ac130003",
            },
          }
        )
        .then((response) => {
          setPost(response.data);
          // console.log("response", response);
          // console.log("response", response.data);
          if (response.data.statuscode === 200) {
            navigate("/success");
          } else {
            setResError(response.data.message);
            setTimeout(function () {
              setResError(null);
            }, 4000);
          }
        })
        .catch((error) => {
          setError(error);
          // console.log(error, "error expected");
          setTimeout(function () {
            setError(null);
          }, 4000);
        });
      setIsLoadingg(false);
    }
  };

  // const onFinishFailed = (errorInfo) => {
  //   console.log("Failed:", errorInfo);
  // };

  // let content = <p> </p>;

  // if (error) {
  //   content = <p className="text-center"> {error}</p>;
  // }
  return (
    <div className="bg-[#F5F3F5] pt-[87px] pb-[87px]" id="joinwaitlist">
      <div className="max-w-[964px] px-[40px] mx-auto">
        <div className="max-w-[598px] mx-auto">
          <h2 className="text-tahiti md:text-[50px] text-[20px] leading-[24px] md:leading-[59px]  text-center font-[700] pb-[20px]">
            {" "}
            <span className="text-tahiti-secondary "> Join </span> Our Waitlist
          </h2>
          <p className=" mx-auto text-[14px]  md:text-[20px]   text-center font-[400]  leading-[24px] md:leading-[34px] pb-[37px]">
            Get An Invite To Sell When Shopaz Hub E-Marketplace Goes LIVE
          </p>
        </div>

        <Form
          {...formItemLayout}
          layout={formLayout}
          form={form}
          initialValues={{
            remember: true,
            layout: formLayout,
          }}
          onFinish={onFinish}
          // onFinishFailed={onFinishFailed}
        >
          <div className="flex flex-col md:flex-row   md:gap-[30px] lg:gap-[66px]">
            <div className="basis-full  md:basis-2/4">
              <Form.Item
                label="Full Name"
                name="fullname"
                rules={[
                  {
                    required: true,
                    message: "Please input your Full Name",
                  },
                ]}
              >
                <Input placeholder="Full Name" className="h-[48px]" />
              </Form.Item>
            </div>

            <div className="basis-full  md:basis-2/4">
              <Form.Item
                label="Email Address"
                name="emailaddress"
                rules={[
                  {
                    required: true,
                    type: "email",
                    message: "Please input your Email Address",
                  },
                ]}
              >
                <Input placeholder="Email Address" className="h-[48px]" />
              </Form.Item>
            </div>
          </div>

          <div className="flex flex-col md:flex-row   md:gap-[30px] lg:gap-[66px]">
            <div className="basis-full  md:basis-2/4">
              <Form.Item
                label="Phone Number"
                name="phonenumber"
                rules={[
                  {
                    required: true,
                    message: "Please input your Phone number",
                  },
                ]}
              >
                <Input
                  placeholder="Phone number"
                  type="number"
                  className="h-[48px]"
                  minLength={11}
                  maxLength={15}
                />
              </Form.Item>
            </div>

            <div className="basis-full  md:basis-2/4">
              <Form.Item
                label="Referral Email (Optional)"
                name="referralemail"
                rules={[
                  {
                    type: "email",
                    message: "Please input a valid Email Address",
                  },
                ]}
              >
                <Input placeholder="Referral email" className="h-[48px]" />
              </Form.Item>
            </div>
          </div>

          <Form.Item>
            <div className="flex justify-center w-full pt-[16px]">
              <Button
                type="primary"
                htmlType="submit"
                className=" w-full h-[52px] bg-tahiti text-[#ffffff] rounded-[6px] rounded-bl-[0] font-[700]"
                loading={isLoadingg}
              >
                JOIN WAITLIST
              </Button>

              {/* {isLoadingg && <div>is loadinggggg..................... </div>} */}
            </div>
          </Form.Item>

          <div className="py-[15px]">
            {error && (
              <Alert
                message="Please try again later"
                type="error"
                className="text-center"
              />
            )}
            {resError && (
              <Alert message={resError} type="error" className="text-center" />
            )}
          </div>

          {/* {content} */}
        </Form>
      </div>
    </div>
  );
}

export default FormSec;
